"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { FieldInspectorProps } from "../../lib/inspector";
import type { TeaserItemInspectorProps } from "../../patterns/teaser-grid/teaser-grid";
import {
  TeaserSection,
  type TeaserSectionInspectorProps,
  type TeaserSectionProps,
} from "./teaser-section";

function mergeInspectorField(
  custom: FieldInspectorProps | undefined,
  generated: FieldInspectorProps | undefined
): FieldInspectorProps | undefined {
  if (!(custom || generated)) {
    return;
  }

  return { ...custom, ...generated };
}

export function TeaserSectionPreview(props: Readonly<TeaserSectionProps>) {
  const sectionInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });
  const itemInspector = useContentfulInspectorMode();

  const generatedSectionInspectorProps: TeaserSectionInspectorProps = {
    container: sectionInspector({ fieldId: "internalName" }) ?? undefined,
    items: sectionInspector({ fieldId: "items" }) ?? undefined,
  };

  const inspectorProps: TeaserSectionInspectorProps = {
    container: mergeInspectorField(
      props.inspectorProps?.container,
      generatedSectionInspectorProps.container
    ),
    items: mergeInspectorField(
      props.inspectorProps?.items,
      generatedSectionInspectorProps.items
    ),
  };

  const items = props.items.map((item) => {
    const generatedItemInspectorProps: TeaserItemInspectorProps = {
      container:
        itemInspector({ entryId: item.sys?.id, fieldId: "internalName" }) ??
        undefined,
      image:
        itemInspector({ entryId: item.sys?.id, fieldId: "image" }) ?? undefined,
      link:
        itemInspector({ entryId: item.sys?.id, fieldId: "link" }) ?? undefined,
    };

    return {
      ...item,
      inspectorProps: {
        container: mergeInspectorField(
          item.inspectorProps?.container,
          generatedItemInspectorProps.container
        ),
        image: mergeInspectorField(
          item.inspectorProps?.image,
          generatedItemInspectorProps.image
        ),
        link: mergeInspectorField(
          item.inspectorProps?.link,
          generatedItemInspectorProps.link
        ),
      },
    };
  });

  return (
    <TeaserSection {...props} inspectorProps={inspectorProps} items={items} />
  );
}
